import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ErrorView from '../ui/util/ErrorView'
import LoadingIndicator from '../ui/util/LoadingIndicator'
import { useModal } from '../contexts/ModalContext'
import { useChallengeId } from '../hooks/challenge/useChallengeId'
import { useTeams } from '../hooks/team/useTeams'
import Team from '../model/Team'
import { challengeTeamPath, ScreenPath } from '../navigation'
import SimplePageLayout from '../ui/layout/SimplePageLayout'
import Button from '../ui/primitives/Button'
import TextField from '../ui/primitives/TextField'
import styles from '../ui/team/TeamEntry.module.css'

export default function JoinTeamScreen() {
  const navigate = useNavigate()
  const challengeId = useChallengeId()
  const { showSnackbar } = useModal()
  const { data: teams, isLoading: isLoadingTeams, error: teamsError } = useTeams(challengeId)
  const [code, setCode] = useState('')

  function onSearch(allTeams: Team[]) {
    const team = allTeams.find((item) => item.code === code)
    if (team) {
      navigate(`${ScreenPath.team}/${team.id}`)
    } else {
      showSnackbar('team-not-found', 'No team found with that code', 'error')
    }
  }

  function onCodeChange(newCode: string) {
    const prevCode = code
    if (newCode.length > 7) return
    if (prevCode.length < 3 && newCode.length === 3) newCode += '-'
    if (prevCode.length > 3 && newCode.length === 3) newCode = newCode.slice(0, 2)
    setCode(newCode.toUpperCase())
  }

  const canSearch = code.replace('-', '').length === 6

  return (
    <SimplePageLayout title="Join team" backTo={challengeTeamPath(challengeId)}>
      <div className={styles.stack}>
        <div className={styles.panel}>
          {isLoadingTeams ? (
            <LoadingIndicator />
          ) : teamsError ? (
            <ErrorView error={teamsError} />
          ) : !teams ? null : (
            <div className={styles.form}>
              <TextField
                className={styles.codeInput}
                label="Code"
                placeholder="XXX-XXX"
                value={code}
                onChange={(e) => onCodeChange(e.target.value)}
                autoFocus
                autoCapitalize="characters"
                autoCorrect="off"
                spellCheck={false}
                inputMode="text"
              />
              <p className={styles.hint}>Enter the team code from your leader or invite link</p>
              <div className={styles.actions}>
                <Button onClick={() => onSearch(teams)} disabled={!canSearch}>
                  Find team
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </SimplePageLayout>
  )
}
